import Icon from '@space-lib/components/icon'
import { light, dark } from '@space-lib/styles/themes'
import styled from 'styled-components'

export const DropdownItemsBox = styled.div<{ theme: string }>`
  z-index: 3;
  background-color: ${({ theme }) =>
    theme === light.title ? light.colors.bgPrimary : dark.colors.bgPrimary} !important;
`

export const CustomIcon = styled(Icon)`
  width: 1.25rem;
  height: 1.25rem;
`

export const ButtonIcon = styled(Icon)`
  width: 0.8125rem;
  height: 0.8125rem;
`

export const CommunityText = styled.span`
  min-width: 6.25rem;
  max-width: 10rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ActionBtn = styled.button`
  padding: 0.375rem !important;
`
